import React, { useState, useEffect } from 'react'
import { Sidebar, MainContent } from '../../layouts/components/Structure'
import { Link } from 'react-router-dom'

import DashboardSidebar from './components/DashboardSidebar'
import { FadeInDiv, RingInfoSlideUp, RingInfoSlideUpTop } from '../../components/Animations'

import RingLineOne from '../../assets/images/ring-line-1.svg'
import RingLineTwo from '../../assets/images/ring-line-2.svg'
import RingLineThree from '../../assets/images/ring-line-3.svg'
import RingLineFour from '../../assets/images/ring-line-4.svg'

import RingLineOneTop from '../../assets/images/ring-line-1-top.svg'
import RingLineTwoTop from '../../assets/images/ring-line-2-top.svg'
import RingLineThreeTop from '../../assets/images/ring-line-3-top.svg'
import RingLineFourTop from '../../assets/images/ring-line-4-top.svg'

import { GetSubscription } from '../../store/SubscriptionClient'

import './Dashboard.css'

const RingInfoData = [
    {
        ringId: 1,
        titleText: 'IPSA',
        image: RingLineOne,
        imageTop: RingLineOneTop,
        width: '352',
        marginLeft: '-95px',
        content: 'Enter IPSA to access your Income Protection Software Analysis presentation tool.',
    },
    {
        ringId: 2,
        titleText: 'Tools',
        image: RingLineTwo,
        imageTop: RingLineTwoTop,
        width: '228',
        marginLeft: '-95px',
        content: 'Enter Tools to access your client presentation PowerPoints and eBooks.',
    },
    {
        ringId: 3,
        titleText: 'Training',
        image: RingLineThree,
        imageTop: RingLineThreeTop,
        width: '135',
        marginLeft: '-140px',
        content: 'Enter Training to access your income protection and IPSA training videos.',
    },
    {
        ringId: 4,
        titleText: 'Insights',
        image: RingLineFour,
        imageTop: RingLineFourTop,
        width: '71',
        marginLeft: '-140px',
        content: 'Enter Insights to access your activity and premium goal monitoring tools.',
    },
]

const Dashboard = () => {
    const [ringInfo, setRingInfo] = useState(null)
    const [subscriptionInfo, setSubscriptionInfo] = useState({})
    let ringTimer = null

    useEffect(() => {
        GetSubscription().then((sub) => {
            setSubscriptionInfo(sub.data)
        })
    }, [])

    const RingHoverEnter = (ringNumber) => {
        clearTimeout(ringTimer)

        const selectedRingInfo = RingInfoData.find((p) => p.ringId === ringNumber)
        if (selectedRingInfo) {
            setRingInfo(selectedRingInfo)
        }
    }

    const RingHoverExit = () => {
        ringTimer = setTimeout(() => {
            setRingInfo(null)
        }, 750)
    }

    const GetRingOpacity = (ringNumber) => (!ringInfo || ringInfo.ringId === ringNumber ? 1 : 0.2)

    return (
        <>
            <Sidebar>
                <DashboardSidebar />
            </Sidebar>
            <MainContent>
                <div id="ring-nav">
                    <svg
                        width="582px"
                        height="582px"
                        viewBox="0 0 582 582"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                        <g
                            id="Portal"
                            stroke="none"
                            strokeWidth="1"
                            fill="#0f0835"
                            fillRule="evenodd"
                        >
                            <g
                                id="OP-Portal-–-Dashboard----Simple-v1"
                                transform="translate(-681.000000, -166.000000)"
                            >
                                <g id="icon" transform="translate(681.000000, 166.000000)">
                                    <Link to="/insights">
                                        <path
                                            onMouseEnter={() => RingHoverEnter(4)}
                                            onMouseLeave={() => RingHoverExit(4)}
                                            d="M561.032132,291 L561.032132,291.102006 C560.975463,425.885725 451.296514,535.530672 316.501461,535.530672 C181.661071,535.530672 71.9707887,425.829056 71.9707887,291 C71.9707887,156.170944 181.661071,46.4693281 316.501461,46.4693281 C451.296514,46.4693281 560.975463,156.114275 561.032132,290.897994 L561.032132,291 Z M291,0 C130.54481,0 0,130.54481 0,291 C0,451.45519 130.54481,582 291,582 C451.45519,582 582,451.45519 582,291 C582,130.54481 451.45519,0 291,0 L291,0 Z"
                                            id="ring-4"
                                            fill="#3B2BB3"
                                            opacity={GetRingOpacity(4)}
                                        ></path>
                                    </Link>
                                    <Link to="/training">
                                        <path
                                            onMouseEnter={() => RingHoverEnter(3)}
                                            onMouseLeave={() => RingHoverExit(3)}
                                            d="M508.705262,303.16011 C503.186083,390.889244 430.065462,460.573833 340.976621,460.573833 C248.306546,460.573833 172.919322,385.176649 172.919322,292.505667 C172.919322,199.823351 248.306546,124.426167 340.976621,124.426167 C430.065462,124.426167 503.186083,194.110756 508.705262,281.83989 C508.897924,285.364924 508.988588,288.923961 508.988588,292.505667 C508.988588,296.076039 508.897924,299.635076 508.705262,303.16011 M315.477334,78 C197.217309,78 101,174.230019 101,292.505667 C101,410.781315 197.217309,507 315.477334,507 C429.748138,507 523.438184,417.173981 529.637343,304.406906 C529.875337,300.47383 530,296.495416 530,292.505667 C530,288.504584 529.875337,284.52617 529.637343,280.593094 C523.438184,167.837354 429.748138,78 315.477334,78"
                                            id="ring-3"
                                            fill="#1E90D9"
                                            opacity={GetRingOpacity(3)}
                                        ></path>
                                    </Link>
                                    <Link to="/tools">
                                        <path
                                            onMouseEnter={() => RingHoverEnter(2)}
                                            onMouseLeave={() => RingHoverExit(2)}
                                            d="M368.50308,383.527721 C318.040986,383.527721 276.975359,342.462094 276.975359,292 C276.975359,241.526571 318.040986,200.472279 368.50308,200.472279 C418.965175,200.472279 460.030801,241.526571 460.030801,292 C460.030801,342.462094 418.965175,383.527721 368.50308,383.527721 M343,154 C266.910144,154 205,215.898809 205,292 C205,368.089856 266.910144,430 343,430 C419.089856,430 481,368.089856 481,292 C481,215.898809 419.089856,154 343,154"
                                            id="ring-2"
                                            fill="#00F6FF"
                                            opacity={GetRingOpacity(2)}
                                        ></path>
                                    </Link>
                                    <Link to="/clients">
                                        <path
                                            onMouseEnter={() => RingHoverEnter(1)}
                                            onMouseLeave={() => RingHoverExit(1)}
                                            d="M368.5,231 C334.041475,231 306,259.041475 306,293.5 C306,327.958525 334.041475,356 368.5,356 C402.958525,356 431,327.958525 431,293.5 C431,259.041475 402.958525,231 368.5,231"
                                            id="ring-1"
                                            fill="#28FF65"
                                            opacity={GetRingOpacity(1)}
                                        ></path>
                                    </Link>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <h1 id="ring-title" className={ringInfo ? 'fade-out' : 'fade-in'}>
                        Explore your system by hovering a ring
                    </h1>
                    {ringInfo && (
                        <>
                            <div className="ring-desc" key={ringInfo.ringId}>
                                <h2>
                                    {ringInfo.titleText}
                                    <img
                                        src={ringInfo.imageTop}
                                        alt="ring-line"
                                        width={ringInfo.width}
                                        className={'ring-' + ringInfo.ringId}
                                        // style={{ marginLeft: ringInfo.marginLeft }}
                                    />
                                </h2>
                            </div>
                        </>
                    )}
                </div>
                {subscriptionInfo &&
                    subscriptionInfo.status === 'trialing' &&
                    subscriptionInfo.paymentSetup !== 'Yes' && (
                        <div id="free-trial-banner">
                            <div className="header">
                                <h2>IMPORTANT</h2>
                            </div>
                            <div className="header">
                                <h2>
                                    <b>
                                        <i style={{ color: 'red' }}>
                                            Make sure you bookmark this portal landing page to your
                                            browser.
                                        </i>
                                    </b>
                                </h2>
                            </div>
                            <div className="sub-header">
                                <b>Your free trial ends on: </b>
                                <p>
                                    <b>
                                        {new Date(subscriptionInfo.trialEnd).toLocaleDateString(
                                            'en-US',
                                            {
                                                weekday: 'long',
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                            }
                                        )}
                                    </b>
                                </p>
                            </div>
                            <div className="body">
                                {subscriptionInfo.homePageDisplayMessage === 'Enhanced' ? (
                                    <>
                                        <div>
                                            <p>
                                                Following your free trial period, your monthly plan
                                                is $59/month (reg. $99)
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                You must subscribe prior to your trial expiration
                                                date, which will not affect the balance of your free
                                                trial period.
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div>
                                            <b>Trial Conversion Pricing:</b>
                                            <p>
                                                To secure your discounted plan pricing, you must
                                                subscribe prior to your free trial end date.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                Discounted plan pricing is only available during
                                                your trial period.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                Regardless of when you subscribe, your initial
                                                payment will not draft until on or shortly after
                                                your free trial end date.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <b>Monthly Plan: $79/month</b> (reg. $99)
                                            </p>
                                        </div>
                                    </>
                                )}

                                <div className="select-plan-container">
                                    <Link
                                        to="/account/subscription"
                                        className="btn select-plan-button"
                                    >
                                        SUBSCRIBE NOW
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
            </MainContent>
        </>
    )
}

export default Dashboard
